export default __webpack_public_path__ + "static/media/cart.2e78a48f.svg";